import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useCreateExternalUserInlineSectionStyles = () => {
    const theme = useTheme();

    return createSxStyles({
        // The form's fields space themselves with their own bottom margin, so this only has to sit the link
        // close above the first one.
        container: {
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            marginTop: 1,
            // Separates the block from the field that follows it, in both the collapsed and the expanded state.
            marginBottom: 2,
        },
        toggleLink: {
            fontSize: theme.typography.pxToRem(12),
            color: theme.palette.primary.main,
            width: "fit-content",
            "&:hover": {
                cursor: "pointer",
                textDecoration: "underline",
            },
        },
    });
};
